<template>
  <div class="wechatContain">
    <CommonHeader
        class="commonHeaderContain"
        v-if="$route.name !== 'detail'"
        @checkNavStates="checkNavStates"
    />
    <CommonNav
        class="commonNavContain"
        :isShowNav="isShowNav"
        @checkNavStates="checkNavStates"
    />
    <div class="wechatAllPage">
      <!-- <keep-alive> -->
        <router-view ref="childFun" v-if="RouterShow" @searchIndex="searchIndex"></router-view>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import CommonHeader from "./commonHeader";
import CommonNav from "./commonNav";
import {myMixin} from '@/mixins/tool.js'

export default {
  name: "mobile",
  mixins: [myMixin],
  components: {CommonHeader, CommonNav},
  data() {
    return {
      isShowNav: false
    }
  },
  mounted() {
  },
  methods: {
    checkNavStates() {
      this.isShowNav = !this.isShowNav;
    },
    searchIndex(val) {
      this.$router.push('/workflow/serviceCenter');
      setTimeout(() => {
        this.$refs['childFun'].toSearch(val);
      }, 100);
    }
  }
};
</script>
<style lang="less">
@import "~@/assets/todoCenter/default/css/wechat.less";

.wechatContain {
  height: 100%;
}
.commonHeaderContain{
  background: linear-gradient(to right, var(--bgColor1), var(--bgColor2));
}
</style>




// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/index.vue